import React from 'react';
import { Tabs } from '@packages/ui/composites';
import type { FormTabsNode } from '../../types/layout';
import { FormNodeRenderer } from '../FormNodeRenderer';

interface TabsRendererProps {
  node: FormTabsNode;
  namePrefix?: string;
}

export const FormTabsRenderer = React.memo(function FormTabsRenderer({ node, namePrefix }: TabsRendererProps): React.ReactElement {
  const defaultTab = node.tabs[0]?.id ?? '';

  return (
    <Tabs.Root defaultValue={defaultTab} semanticId={node.semanticId} centered={node.centered}>
      <Tabs.List>
        {node.tabs.map((tab) => (
          <Tabs.Trigger key={tab.id} value={tab.id} disabled={tab.disabled}>
            {tab.label}
          </Tabs.Trigger>
        ))}
      </Tabs.List>

      {node.tabs.map((tab) => (
        <Tabs.Content key={tab.id} value={tab.id}>
          {tab.children.map((child, idx) => (
            <FormNodeRenderer key={idx} node={child} namePrefix={namePrefix} />
          ))}
        </Tabs.Content>
      ))}
    </Tabs.Root>
  );
});
